import React from 'react';
import Img from 'gatsby-image';
import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import { Checklist, Discussion, Stories } from '../../icons';
import { SectionHeader } from '../../components/sectionHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import { aboutUsData } from '../../components/data';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import { Link } from 'gatsby';
import Button from '../../components/button';

const IchhyaStory = () => {
  const theme = useTheme();
  const isMobile = !useMediaQuery(theme.breakpoints.up('sm'));
  const {
    nepali: { description },
  } = aboutUsData;
  return (
    <Grid
      container
      justify="center"
      style={{ marginBottom: isMobile ? '24px' : 0 }}
    >
      <Grid item xs={12} sm={12} md={12} lg={12}>
        {description.map(paragraph => (
          <Typography
            key={paragraph.slice(1, 10)}
            variant="body1"
            gutterBottom
          >
            {paragraph}
          </Typography>
        ))}
      </Grid>
    </Grid>
  );
};
const ImageTextBlock = ({
  textDirection,
  image,
  header,
  descriptions,
  followIcons,
  actionLink,
}) => {
  const theme = useTheme();
  const isMediumAndSmall = useMediaQuery(
    theme.breakpoints.down('sm')
  );
  return (
    <Grid
      container
      direction={
        isMediumAndSmall
          ? 'column'
          : textDirection === 'right'
          ? 'row-reverse'
          : 'row'
      }
      wrap="nowrap"
      style={{
        width: '100%',
        padding: isMediumAndSmall ? '32px 0' : '64px 0',
      }}
      justify="space-between"
    >
      <Grid item container justify="center">
        {image}
      </Grid>
      <Grid
        item
        container
        direction="column"
        alignContent="center"
        justify="center"
        style={{ padding: '16px' }}
      >
        <Grid item>
          <Typography
            variant="h6"
            gutterBottom
            align={isMediumAndSmall ? 'center' : 'left'}
            style={{ color: '#016096', fontWeight: 600 }}
          >
            {header}
          </Typography>
        </Grid>
        <Grid item>
          {descriptions.map(description => (
            <Typography variant="body1" paragraph key={description}>
              {description}
            </Typography>
          ))}
        </Grid>
        {actionLink && (
          <Grid item container justify="center">
            <Link to={actionLink}>
              <Button size="small">
                <DoubleArrowIcon style={{ color: '#fff' }} />
              </Button>
            </Link>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export const PersonInfoBlock = ({
  image,
  name,
  profession,
  about,
}) => {
  const theme = useTheme();
  const isMediumAndSmall = useMediaQuery(
    theme.breakpoints.down('sm')
  );
  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      justify="center"
      style={{ padding: 16 }}
    >
      <Grid
        item
        container
        alignItems="center"
        justify="center"
        style={{ padding: isMediumAndSmall ? '16px 0' : '8px 0' }}
      >
        {image}
      </Grid>
      <Grid
        item
        xs={isMediumAndSmall ? 12 : 8}
        container
        justify="flex-start"
      >
        <Grid
          item
          container
          alignItems="center"
          justify={isMediumAndSmall ? 'flex-start' : 'center'}
          style={{ paddingTop: 8 }}
        >
          <Typography
            variant="body1"
            display="inline"
            style={{ fontWeight: 700 }}
            gutterBottom
          >
            {name}
          </Typography>
        </Grid>
        <Grid item style={{ paddingTop: 8 }}>
          {about.map(paragraph => (
            <Typography
              key={paragraph.slice(1, 10)}
              variant="body1"
              gutterBottom
              style={{ paddingBottom: 8 }}
            >
              {paragraph}
            </Typography>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

const OurStorySection = ({ rosyImage, banditaImage }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const {
    nepali: { header, sections },
  } = aboutUsData;
  return (
    <Box width="100%" p={isMobile ? '24px' : '64px'}>
      <SectionHeader title={header} id="our-story" lineBottom />
      <IchhyaStory />
      <ImageTextBlock
        image={<Checklist width={350} />}
        header={sections[0].header}
        descriptions={sections[0].description}
        actionLink={'/questionnaire'}
      />
      <ImageTextBlock
        textDirection="right"
        image={<Discussion width={500} />}
        header={sections[1].header}
        descriptions={sections[1].description}
        actionLink={'/manas-gyankosh'}
      />
      <ImageTextBlock
        image={<Stories width={450} />}
        header={sections[2].header}
        descriptions={sections[2].description}
        actionLink={'/prerana-manch'}
      />
      <Typography
        variant="body2"
        align="center"
        style={{
          marginTop: isMobile ? '16px' : '24px',
          fontWeight: 600,
        }}
      >
        हाम्रो कथा
      </Typography>
      <PersonInfoBlock
        image={
          <Img
            fixed={rosyImage}
            style={{
              borderRadius: '50%',
            }}
          />
        }
        name="राेजी पुन"
        about={[
          "St. Xavier's college बाट सामाजिक कार्यमा स्नातक गरी थाईल्याड काे Asian Institute of Technology (AIT) बाट स्नातकोत्तर सकेर, राेजी पुन स्वदेशमा नै केही गर्ने भावना लिएर नेपाल फर्किन् । स्वास्थ्य र फिटनेस छेत्रमा विशेष रुचि र १८ वर्षको अनुभव भएकी रोजी हाल काठमाडौँ स्थित निरामय फिटनेसकाे संस्थापक हुन् । यो अन्तरालमा उनले व्यायाम, योग र ध्यान मानिसको समग्र स्वास्थ्यको लागि फाइदाजनक भएको पाइन् । स्वस्थ र सुखी जीवनको  लागि शारीरिक फिटनेस संगसंगै मानसिक फिटनेसको भूमिकामा सबैको ध्यान केन्द्रित गर्ने अभिलाषाका साथ उनी इच्छाशक्तिमा संलग्न छिन् ।",
        ]}
      />
      <PersonInfoBlock
        image={
          <Img fixed={banditaImage} style={{ borderRadius: '50%' }} />
        }
        name="बन्दिता शर्मा"
        about={[
          "St. Xavier's college ko सामाजिक कार्य संकायको पूर्व विद्यार्थी बन्दिता शर्मा हाल अस्ट्रेलियाको not-for-profit संस्थामा सफ्टवेयर डेभ्लपरको रुपमा कार्यरत छिन् । सामाजिक भलाईको लागि टेकनोलोजीको प्रयोग (Tech for social good ), social entrepreneurship र social innovation जस्ता विषयमा विशेष चासो राख्ने बन्दिता आफ्नो सामाजिक सेवा र टेकनोलोजीको छेत्रमा भएको सीप र अनुभवको प्रयोग गरेर सामाजिक समस्याहरुको समाधानका innovative विकल्पहरु खोज्न र अन्वेषण गर्न तत्पर छिन् ।",
          'शारीरिक स्वास्थ्य संगसंगै सबैले आफ्नो भावनात्मक, मनोवैज्ञानिक र सामाजिक कल्याणको लागि सक्रिय रहनुपर्छ र आफ्ना साथीभाई, परिवार र छरछिमेकमा पनि सबैलाई प्रेरित गर्नुपर्छ भन्ने सन्देश उनी इच्छाशक्ति मार्फत सबैलाई दिन चाहन्छिन् ।',
        ]}
      />
    </Box>
  );
};

export default OurStorySection;
